import React, { forwardRef } from "react";
import MuiAlert from "@material-ui/core/Alert";

export default forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});